import React, { useEffect, useRef, useState, lazy, Suspense } from "react";
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import { captureUtmParams, installTallyUtmHandlers, applyUtmToTallyIframes } from './utils/utm';
import { trackPageView } from './utils/tracker';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slickFontDisplay.css";

import { ResumeDataProvider } from './components/Context/ResumeContext';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// Resume Builder Components
const FormComponent = lazy(() => import('./FormComponent'));
const FormComponent_2 = lazy(() => import('./FormComponent_2'));
const FormComponent_3 = lazy(() => import('./FormComponent_3'));
const ResHero = lazy(() => import('./components/ResHero'));
const Resume = lazy(() => import('./components/Template1/Resume'));
const Resume2 = lazy(() => import('./components/Template2/Resume2'));
const Resume3 = lazy(() => import('./components/Template3/Resume3'));
const Resume4 = lazy(() => import('./components/Template4/Resume4'));
const Resume5 = lazy(() => import('./components/Template5/Resume5'));
const Resume6 = lazy(() => import('./components/Template6/Resume6'));
const Resume7 = lazy(() => import('./components/Template7/Resume7'));
const Resume8 = lazy(() => import('./components/Template8/Resume8'));
const Resume9 = lazy(() => import('./components/Template9/Resume9'));
const Resume10 = lazy(() => import('./components/Template10/Resume10'));
const ChooseTemplate = lazy(() => import('./components/ChooseTemplate'));
const SearchedOutput = lazy(() => import('./pages/SearchedOutput'));

//Blog Compoents
const Blog = lazy(() => import("./components/Blog/Blog"));
const Page1 = lazy(() => import("./components/Blog/Page1"));
const Page2 = lazy(() => import("./components/Blog/Page2"));
const Page3 = lazy(() => import("./components/Blog/Page3"));
const Page4 = lazy(() => import("./components/Blog/Page4"));
const Page5 = lazy(() => import("./components/Blog/Page5"));
const Page6 = lazy(() => import("./components/Blog/Page6"));
const Page7 = lazy(() => import("./components/Blog/Page7"));
const Page8 = lazy(() => import("./components/Blog/Page8"));
const Page9 = lazy(() => import("./components/Blog/Page9"));
const Page10 = lazy(() => import("./components/Blog/Page10"));
const Page11 = lazy(() => import("./components/Blog/Page11"));
const Page12 = lazy(() => import("./components/Blog/Page12"));
const Page13 = lazy(() => import("./components/Blog/Page13"));
const Page14 = lazy(() => import("./components/Blog/Page14"));
const Page15 = lazy(() => import("./components/Blog/Page15"));
const Page16 = lazy(() => import("./components/Blog/Page16"));
const Page17 = lazy(() => import("./components/Blog/Page17"));
const Page18 = lazy(() => import("./components/Blog/Page18"));
const Page19 = lazy(() => import("./components/Blog/Page19"));
const Page20 = lazy(() => import("./components/Blog/Page20"));
const Page21 = lazy(() => import("./components/Blog/Page21"));
const Page22 = lazy(() => import("./components/Blog/Page22"));
const Page23 = lazy(() => import("./components/Blog/Page23"));
const Page24 = lazy(() => import("./components/Blog/Page24"));
const Page25 = lazy(() => import("./components/Blog/Page25"));
const Page26 = lazy(() => import("./components/Blog/Page26"));
const Page27 = lazy(() => import("./components/Blog/Page27"));
const Page28 = lazy(() => import("./components/Blog/Page28"));
const Page29 = lazy(() => import("./components/Blog/Page29"));
const Page30 = lazy(() => import("./components/Blog/Page30"));
const Page31 = lazy(() => import("./components/Blog/Page31"));
const Page32 = lazy(() => import("./components/Blog/Page32"));
const Page33 = lazy(() => import("./components/Blog/Page33"));
const Page34 = lazy(() => import("./components/Blog/Page34"));
const Page35 = lazy(() => import("./components/Blog/Page35"));
const Page36 = lazy(() => import("./components/Blog/Page36"));
const Page37 = lazy(() => import("./components/Blog/Page37"));
const Page38 = lazy(() => import("./components/Blog/Page38"));
const Page39 = lazy(() => import("./components/Blog/Page39"));
const Page40 = lazy(() => import("./components/Blog/Page40"));
const Page41 = lazy(() => import("./components/Blog/Page41"));
const Page42 = lazy(() => import("./components/Blog/Page42"));
const Page43 = lazy(() => import("./components/Blog/Page43"));
const Page44 = lazy(() => import("./components/Blog/Page44"));
const Page45 = lazy(() => import("./components/Blog/Page45"));
const Page46 = lazy(() => import("./components/Blog/Page46"));
const Page47 = lazy(() => import("./components/Blog/Page47"));
const Page48 = lazy(() => import("./components/Blog/Page48"));
const Page49 = lazy(() => import("./components/Blog/Page49"));
const Page50 = lazy(() => import("./components/Blog/Page50"));
const Page51 = lazy(() => import("./components/Blog/Page51"));
const Page52 = lazy(() => import("./components/Blog/Page52"));
const Page53 = lazy(() => import("./components/Blog/Page53"));
const Page54 = lazy(() => import("./components/Blog/Page54"));
const Page55 = lazy(() => import("./components/Blog/Page55"));
const Page56 = lazy(() => import("./components/Blog/Page56"));
const Page57 = lazy(() => import("./components/Blog/Page57"));
const Page58 = lazy(() => import("./components/Blog/Page58"));
const Page59 = lazy(() => import("./components/Blog/Page59"));
const Page60 = lazy(() => import("./components/Blog/Page60"));
const Page61 = lazy(() => import("./components/Blog/Page61"));
const Page62 = lazy(() => import("./components/Blog/Page62"));
const Page63 = lazy(() => import("./components/Blog/Page63"));
const Page64 = lazy(() => import("./components/Blog/Page64"));
const Page65 = lazy(() => import("./components/Blog/Page65"));
const Page66 = lazy(() => import("./components/Blog/Page66"));
const Page67 = lazy(() => import("./components/Blog/Page67"));
const Page68 = lazy(() => import("./components/Blog/Page68"));
const Page69 = lazy(() => import("./components/Blog/Page69"));
const Page70 = lazy(() => import("./components/Blog/Page70"));
const Page71 = lazy(() => import("./components/Blog/Page71"));
const Page72 = lazy(() => import("./components/Blog/Page72"));
const Page73 = lazy(() => import("./components/Blog/Page73"));
const Page74 = lazy(() => import("./components/Blog/Page74"));
const Page75 = lazy(() => import("./components/Blog/Page75"));
const Page76 = lazy(() => import("./components/Blog/Page76"));
const Page77 = lazy(() => import("./components/Blog/Page77"));
const Page78 = lazy(() => import("./components/Blog/Page78"));
const Page79 = lazy(() => import("./components/Blog/Page79"));
const Page80 = lazy(() => import("./components/Blog/Page80"));
const Page81 = lazy(() => import("./components/Blog/Page81"));
const Page82 = lazy(() => import("./components/Blog/Page82"));
const Page83 = lazy(() => import("./components/Blog/Page83"));
const Page84 = lazy(() => import("./components/Blog/Page84"));
const Page85 = lazy(() => import("./components/Blog/Page85"));
const Page86 = lazy(() => import("./components/Blog/Page86"));
const Page87 = lazy(() => import("./components/Blog/Page87"));
const Page88 = lazy(() => import("./components/Blog/Page88"));
const Page89 = lazy(() => import("./components/Blog/Page89"));
const Page90 = lazy(() => import("./components/Blog/Page90"));
const Page91 = lazy(() => import("./components/Blog/Page91"));
const Page92 = lazy(() => import("./components/Blog/Page92"));
const Page93 = lazy(() => import("./components/Blog/Page93"));
const Page94 = lazy(() => import("./components/Blog/Page94"));
const Page95 = lazy(() => import("./components/Blog/Page95"));
const Page96 = lazy(() => import("./components/Blog/Page96"));
const Page97 = lazy(() => import("./components/Blog/Page97"));
const Page98 = lazy(() => import("./components/Blog/Page98"));
const Page99 = lazy(() => import("./components/Blog/Page99"));
const Page100 = lazy(() => import("./components/Blog/Page100"));
const Page101 = lazy(() => import("./components/Blog/Page101"));
const Page102 = lazy(() => import("./components/Blog/Page102"));
const Page103 = lazy(() => import("./components/Blog/Page103"));
const Page104 = lazy(() => import("./components/Blog/Page104"));
const Page105 = lazy(() => import("./components/Blog/Page105"));
const Page106 = lazy(() => import("./components/Blog/Page106"));
const Page107 = lazy(() => import("./components/Blog/Page107"));
const Page108 = lazy(() => import("./components/Blog/Page108"));
const Page109 = lazy(() => import("./components/Blog/Page109"));
const Page110 = lazy(() => import("./components/Blog/Page110"));
const Page111 = lazy(() => import("./components/Blog/Page111"));
const Page112 = lazy(() => import("./components/Blog/Page112"));
const Page113 = lazy(() => import("./components/Blog/Page113"));
const Page114 = lazy(() => import("./components/Blog/Page114"));
const Page115 = lazy(() => import("./components/Blog/Page115"));
const Page116 = lazy(() => import("./components/Blog/Page116"));
const Page117 = lazy(() => import("./components/Blog/Page117"));
const Page118 = lazy(() => import("./components/Blog/Page118"));
const Page119 = lazy(() => import("./components/Blog/Page119"));
const Page120 = lazy(() => import("./components/Blog/Page120"));
const Page121 = lazy(() => import("./components/Blog/Page121"));
const Page122 = lazy(() => import("./components/Blog/Page122"));
const Page123 = lazy(() => import("./components/Blog/Page123"));
const Page124 = lazy(() => import("./components/Blog/Page124"));
const Page125 = lazy(() => import("./components/Blog/Page125"));
const Page126 = lazy(() => import("./components/Blog/Page126"));
const Page127 = lazy(() => import("./components/Blog/Page127"));
const Page128 = lazy(() => import("./components/Blog/Page128"));
const Page129 = lazy(() => import("./components/Blog/Page129"));
const Page130 = lazy(() => import("./components/Blog/Page130"));
const Page131 = lazy(() => import("./components/Blog/Page131"));
const Page132 = lazy(() => import("./components/Blog/Page132"));
const Page133 = lazy(() => import("./components/Blog/Page133"));
const Page134 = lazy(() => import("./components/Blog/Page134"));
const Page135 = lazy(() => import("./components/Blog/Page135"));
const Page136 = lazy(() => import("./components/Blog/Page136"));
const Page137 = lazy(() => import("./components/Blog/Page137"));
const Page138 = lazy(() => import("./components/Blog/Page138"));
const Page139 = lazy(() => import("./components/Blog/Page139"));
const Page140 = lazy(() => import("./components/Blog/Page140"));
const Page141 = lazy(() => import("./components/Blog/Page141"));
const Page146 = lazy(() => import("./components/Blog/Page146"));
const Page142 = lazy(() => import("./components/Blog/Page142"));
const Page143 = lazy(() => import("./components/Blog/Page143"));
const Page145 = lazy(() => import("./components/Blog/Page145"));
const Page147 = lazy(() => import("./components/Blog/Page147"));
const Page148 = lazy(() => import("./components/Blog/Page148"));
const Page144 = lazy(() => import("./components/Blog/Page144"));
const Page149 = lazy(() => import("./components/Blog/Page149"));
const Page151 = lazy(() => import("./components/Blog/Page151"));
const Page152 = lazy(() => import("./components/Blog/Page152"));
const Page153 = lazy(() => import("./components/Blog/Page153"));
const Page154 = lazy(() => import("./components/Blog/Page154"));
const Page155 = lazy(() => import("./components/Blog/Page155"));
const Page156 = lazy(() => import("./components/Blog/Page156"));
const Page157 = lazy(() => import("./components/Blog/Page157"));
const Page158 = lazy(() => import("./components/Blog/Page158"));

// Lazy loaded components
const Footer = lazy(() => import('./components/Footer'));
const Recognition = lazy(() => import('./components/Recognition'));
const Aws_Course_Details_Page = lazy(() => import('./pages/Aws_Course_Details_Page'));
const Python_Course_Details_Page = lazy(() => import('./pages/Python_Course_Details_Page'));
const Mysql_Course_Details_Page = lazy(() => import('./pages/Mysql_Course_Details_Page'));
const E_Book_2024 = lazy(() => import('./pages/E_Book_2024'));
const Streamyardpage = lazy(() => import('./pages/Streamyardpage'));
const TestimonialsPage = lazy(() => import('./pages/TestimonialsPage'));
const Ebook = lazy(() => import('./pages/Ebook'));
const Survey = lazy(() => import('./pages/Survey'));
const Courses = lazy(() => import('./pages/Courses'));
const Webinar = lazy(() => import('./components/Webinar/Webinar'));
const Hero = lazy(() => import('./components/Webinar/Hero'));
const Hero2 = lazy(() => import('./components/Webinar/Hero2'));
const TestimonialFreshers = lazy(() => import('./pages/TestimonialFreshers'));
const TestimonialExperienced = lazy(() => import('./pages/TestimonialExperienced'));
const Cloud_PlacementDrive_Form = lazy(() => import('./pages/Cloud_PlacementDrive_Form'));
const Offcampus_PlacementDrive_Form = lazy(() => import('./pages/Offcampus_PlacementDrive_Form'));
const Testimonials = lazy(() => import('./pages/Testimonials'));
const YTFullCoursePage = lazy(() => import('./pages/YTFullCoursePage'));
const Legal = lazy(() => import('./pages/Legal'));
const Terms = lazy(() => import('./pages/Terms'));
const Whatsapp = lazy(() => import('./pages/Whatsapp'));
const Kn_Blogs = lazy(() => import('./pages/Kn_Blog'));
const JoinDemo = lazy(() => import('./pages/JoinDemo'));
const Task_Steps = lazy(() => import('./pages/Task_Steps'));
const Privacy = lazy(() => import('./pages/Privacy'));
const BankDetails = lazy(() => import('./pages/BankDetails'));
const ThankYou = lazy(() => import('./pages/ThankYou'));
const Thank_You = lazy(() => import('./pages/Thank_You'));
const AWS_FAQ = lazy(() => import('./pages/AWS_FAQ'));
const Demo_Form = lazy(() => import('./pages/Demo_Form'));
const AWS_DevOps = lazy(() => import('./pages/AWS_DevOps'));
const FreeTrial = lazy(() => import('./pages/Free_Trial'));
const Zoom_Link_AWS = lazy(() => import('./pages/Zoom_Link_AWS'));
const Webinar_Youtube_Live = lazy(() => import('./pages/Webinar_Youtube_Live'));
const Webinar_registration = lazy(() => import('./pages/Webinar_Registration'));
const Company_Vacancies = lazy(() => import('./pages/Company_Vacancies'));
const Webinar_Link = lazy(() => import('./pages/Webinar_Link'));
const E_Book = lazy(() => import('./pages/E_Book'));
const EBook_SheetFill = lazy(() => import('./pages/EBook_SheetFill'));
const Ship_Delivery_Policy = lazy(() => import('./pages/Ship_Delivery_Policy'));
const E_Book_Aug18 = lazy(() => import('./pages/E_Book_Aug18'));
const AWS_DevOps_Curriculm = lazy(() => import('./pages/AWS_DevOps_Curriculum'));
const AWS_Demo_Link = lazy(() => import('./pages/AWS_Demo_Link'));
const PaymentLink = lazy(() => import('./pages/PaymentLink'));
const Devopsforkannadigas = lazy(() => import('./pages/Devopsforkannadigas'));
const Pythonforkannadigas = lazy(() => import('./pages/Pythonforkannadigas'));
const PowerBi = lazy(() => import('./pages/PowerBi'));
const Java_at = lazy(() => import('./pages/Java-at'));
const Topper_of_the_month = lazy(() => import('./pages/Topper_of_the_month'));
const PythonQuiz = lazy(() => import('./pages/PythonQuiz'));
const Awsdevops = lazy(() => import('./components/Aws & DevOps/Awsdevops'));
const Pythonfullstack = lazy(() => import('./components/Python-Fullstack/Pythonfullstack'));
const Pythonfullstack2 = lazy(() => import('./components/Python-Fullstack-New/Pythonfullstack'));
const DockerAndKubernetesCertificationPage = lazy(() => import('./pages/DockerAndKubernetesCertificationPage'));
const Offcampus_PlacementDrive_Jan2025 = lazy(() => import('./pages/Offcampus_PlacementDrive_Jan2025'));
const SkillGapAnalyzer = lazy(() => import('./components/SkillGapAnayzer/Skillgapanalyzer'));
const Roi_Calculator = lazy(() => import('./pages/roi-calculator'));
const SalaryCalculator = lazy(() => import('./pages/salary-calculator'));
const TrainersHiringForm = lazy(() => import('./pages/TrainersHiringForm'));
const InterviewQuestions = lazy(() => import('./pages/InterviewQuestions'));
const AndroidApp = lazy(() => import('./components/Android App/AndroidApp'));
const Student_Intake_Form = lazy(() => import('./pages/Student_Intake_Form'));
const Downloadcurriculum = lazy(() => import('./pages/Download_Curriculum'));
const Singlepage = lazy(() => import('./components/Single Page/Singlepage'));
const Singlepage2 = lazy(() => import('./components/Single Page copy/Singlepage'));
const Singlepage3 = lazy(() => import('./components/Single Page copy 2/Singlepage'));
const Video = lazy(() => import('./components/Single Page/Video'));
const Video2 = lazy(() => import('./components/Single Page copy/Video'));
const Video3 = lazy(() => import('./components/Single Page copy 2/Video'));
const Prime = lazy(() => import('./components/Prime/Prime'));
const Cashback = lazy(() => import('./components/Cashback/Cashback'));
const Awsdevops2 = lazy(() => import('./components/Aws & DevOps 2/Awsdevops'));
const Genai = lazy(() => import('./components/Genai/Genai'));
const Kannadaoffer = lazy(() => import('./components/KannadaOffer/Kannadaoffer'));
const Sixthoffer = lazy(() => import('./components/SixthOffer/SixthOffer'));
const NewYear = lazy(() => import('./components/New Year/NewYear'));
const WebinarPage = lazy(() => import('./components/Masterclass/WebinarPage'));
const Masterclass2 = lazy(() => import('./components/Masterclass 2/Masterclass2'));
const Th = lazy(() => import('./components/Th'));
const DFK = lazy(() => import('./components/DevOpsforKannadigas/DFK'));
const CFK = lazy(() => import('./components/CloudforKannadigas/CFK'));
const Video4 = lazy(() => import('./components/DevOpsforKannadigas/Video4'));
const Demopage = lazy(() => import('./components/Demo Page/Demopage'));
const Genaidemo = lazy(() => import('./components/Genai Demo Page/Genaidemo'));
const Demo1 = lazy(() => import('./components/Demo Page/Demo1'));
const Demo2 = lazy(() => import('./components/Demo Page/Demo2'));
const Demo3 = lazy(() => import('./components/Genai Demo Page/Demo4'));
const QuizApp = lazy(() => import('./components/Quiz/QuizApp'));
const Thankyoupage1 = lazy(() => import('./components/Thank You Page/ThankyouPage1'));
const Thankyoupage2 = lazy(() => import('./components/Thank You Page/ThankyouPage2'));
const Thankyoupage3 = lazy(() => import('./components/Thank You Page/ThankyouPage3'));
const Thankyoupage4 = lazy(() => import('./components/Thank You Page/ThankyouPage4'));
const Thankyoupage5 = lazy(() => import('./components/Thank You Page/ThankyouPage5'));
const Thankyoupage6 = lazy(() => import('./components/Thank You Page/ThankyouPage6'));
const Thankyoupage7 = lazy(() => import('./components/Thank You Page/ThankyouPage7'));
const Thankyoupage8 = lazy(() => import('./components/Thank You Page/ThankyouPage8'));
const Thankyoupage9 = lazy(() => import('./components/Thank You Page/ThankyouPage9'));
const ThankyouPageforNonIT = lazy(() => import('./components/Thank You Page/ThankyouPageforNonIT'));
const Aiforkannadigas = lazy(() => import('./pages/aiforkannadigas'));
const Cloudforkannadigas2 = lazy(() => import('./pages/Cloudforkannadigas'));
const Adpage = lazy(() => import('./components/Ad Page/AdPage'));
const Adpage2 = lazy(() => import('./components/Ad Page 2/AdPage'));

const LayoutWithNavbar = ({ children }) => (
  <>
    <Navbar />
    {children}
  </>
);

const LayoutWithoutNavbar = ({ children }) => <>{children}</>;

const AppInner = ({ setSearchedResults, handleAlert, searchedResults }) => {
  const location = useLocation();
  const showNavAndFooter =
    location.pathname !== '/genaicourse' &&
    location.pathname !== '/cloud-devops-certification' &&
    location.pathname !== '/tech-course';

  // Capture UTM params on every navigation so real ad attribution survives
  // internal link clicks, even before any lead form mounts.
  useEffect(() => {
    captureUtmParams(location.search);
    applyUtmToTallyIframes();
  }, [location.pathname, location.search]);

  // Send saved UTMs to Tally popups / links / embeds site-wide.
  useEffect(() => installTallyUtmHandlers(), []);

  // Anonymous page-view tracking (after captureUtmParams above so the visitor's
  // first-touch UTMs are already saved when a new session starts).
  useEffect(() => {
    trackPageView();
  }, [location.pathname]);

  // Ad landing pages use a different phone conversion number
  useEffect(() => {
    const phoneLink = document.getElementById('fixedPhoneLink');
    if (!phoneLink) return;

    const isAdCoursePage =
      location.pathname === '/cloud-devops-certification' ||
      location.pathname === '/tech-course' ||
      location.pathname === '/tech-courses' ||
      location.pathname === '/genaicourse';

    const phoneTel = isAdCoursePage
      ? 'tel:+918069484577'
      : 'tel:+918047109999';

    phoneLink.setAttribute('href', phoneTel);
    phoneLink.setAttribute(
      'onclick',
      `return gtag_report_conversion('${phoneTel}');`
    );
  }, [location.pathname]);

  return (
    <>
      {showNavAndFooter && <Navbar setSearchedResults={setSearchedResults} />}
      <ResumeDataProvider>
        <main style={{ display: 'contents' }}>
        <Suspense fallback={<h1 style={{ minHeight: '100vh' }}>Loading...</h1>}>
          <Routes>
            {/* Home Route with Search Results */}
            {searchedResults.length !== 0
              ? <Route exact path="/" element={<SearchedOutput searchedResults={searchedResults} setSearchedResults={setSearchedResults} />} />
              : <Route exact path="/" element={<Home handleAlert={handleAlert} />} />
            }

            {/* Blog Routes */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/tech-support-to-devops" element={<Page1 />} />
            <Route path="/blog/devops-engineer-salary-india" element={<Page2 />} />
            <Route path="/blog/top-5-devops-jobs-india" element={<Page3 />} />
            <Route path="/blog/top-5-devops-jobs-india-2025" element={<Page3 />} />
            <Route path="/blog/software-tester-to-devops-2025" element={<Page4 />} />
            <Route path="/blog/aws-azure-gcp-career-growth-india-2025" element={<Page5 />} />
            <Route path="/blog/ultimate-aws-cpc-guide-2025" element={<Page6 />} />
            <Route path="/blog/aws-saa-guide-2025" element={<Page7 />} />
            <Route path="/blog/devops-vs-devsecops" element={<Page8 />} />
            <Route path="/blog/aws-services" element={<Page9 />} />
            <Route path="/blog/devops-tools" element={<Page10 />} />
            <Route path="/blog/why-learn-aws-devops" element={<Page11 />} />
            <Route path="/blog/genai-in-devops" element={<Page12 />} />
            <Route path="/blog/aws-best-practices" element={<Page13 />} />
            <Route path="/blog/devops-learning-roadmap-2025" element={<Page14 />} />
            <Route path="/blog/ai-native-azure-services-beginners-guide" element={<Page15 />} />
            <Route path="/blog/agentic-ai-aws-everything-you-need-to-know" element={<Page16 />} />
            <Route path="/blog/cloud-ai-skills-data-engineers-future-proof-careers" element={<Page17 />} />
            <Route path="/blog/real-time-data-processing-ai-cloud-tools-data-engineers" element={<Page18 />} />
            <Route path="/blog/why-learning-cloud-and-ai-monitoring-tools-can-transform-your-admin-career" element={<Page19 />} />
            <Route path="/blog/automation-ai-tools-testers-improve-accuracy" element={<Page20 />} />
            <Route path="/blog/ai-powered-testing-help-developers-detect-bugs-early" element={<Page21 />} />
            <Route path="/blog/system-administrators-automate-tasks-cloud-devops-ai-tools" element={<Page22 />} />
            <Route path="/blog/cloud-data-warehouses-ai-tools-scalable-data-management" element={<Page23 />} />
            <Route path="/blog/public-cloud-vs-private-cloud-beginners-guide" element={<Page24 />} />
            <Route path="/blog/devops-safest-career-move-it-professionals-2025" element={<Page25 />} />
            <Route path="/blog/top-10-azure-services-beginners-2025" element={<Page26 />} />
            <Route path="/blog/best-cloud-devops-tools-developers-2025" element={<Page27 />} />
            <Route path="/blog/devsecops-made-simple-security-essential-devops-pipelines" element={<Page28 />} />
            <Route path="/blog/aws-lambda-vs-ec2-which-one-beginners-learn-first-2025" element={<Page29 />} />
            <Route path="/blog/cicd-basics-explained-what-every-student-must-know-before-learning-devops" element={<Page30 />} />
            <Route path="/blog/kubernetes-made-simple-beginners-guide-it-students-professionals" element={<Page31 />} />
            <Route path="/blog/best-cloud-test-environments-automation-learn-set-up" element={<Page32 />} />
            <Route path="/blog/infrastructure-as-code-automating-server-setup-terraform-ansible" element={<Page33 />} />
            <Route path="/blog/how-developers-speed-up-releases-cloud-devops-tools" element={<Page34 />} />
            <Route path="/blog/why-learning-cloud-devops-skills-essential-developers-stay-competitive" element={<Page35 />} />
            <Route path="/blog/containers-serverless-architectures-accelerate-development" element={<Page36 />} />
            <Route path="/blog/how-to-scale-server-infrastructure-fast-using-cloud-technologies-practical-guide" element={<Page37 />} />
            <Route path="/blog/cloud-testing-skills-testers-2025" element={<Page38 />} />
            <Route path="/blog/cloud-testing-skills-testers" element={<Page38 />} />
            <Route path="/blog/qa-testers-automate-regression-testing-cloud-tools" element={<Page39 />} />
            <Route path="/blog/data-engineers-handle-big-data-spikes-cloud-ai-solutions" element={<Page40 />} />
            <Route path="/blog/devops-roadmap-application-support-engineers-2026" element={<Page41 />} />
            <Route path="/blog/linux-for-cloud-it-professionals-transition" element={<Page42 />} />
            <Route path="/genai-skills-software-engineers" element={<Page43 />} />
            <Route path="/blog/high-paying-cloud-certifications-experienced-it-professionals" element={<Page44 />} />
            <Route path="/blog/best-aws-monitoring-tools-for-devops-engineers" element={<Page45 />} />
            <Route path="/blog/aws-data-engineer-roadmap-working-professionals-2026" element={<Page46 />} />
            <Route path="/blog/cloud-engineer-vs-devops-engineer" element={<Page47 />} />
            <Route path="/blog/single-agent-vs-multi-agent-systems" element={<Page48 />} />
            <Route path="/blog/devsecops-roadmap-working-professionals-2026" element={<Page49 />} />
            <Route path="/blog/90-day-cloud-devops-learning-plan-working-professionals" element={<Page50 />} />
            <Route path="/blog/docker-best-practices-for-production-deployments" element={<Page51 />} />
            <Route path="/blog/highest-paying-cloud-jobs-india-cloud-salary-guide" element={<Page52 />} />
            <Route path="/blog/best-ai-agent-frameworks-for-developers" element={<Page53 />} />
            <Route path="/blog/aws-vs-azure-vs-gcp-career-growth-2026" element={<Page54 />} />
            <Route path="/blog/terraform-vs-ansible-which-to-learn-first" element={<Page55 />} />
            <Route path="/blog/manual-testing-to-devops-career-transition" element={<Page56 />} />
            <Route path="/blog/site-reliability-engineer-sre-career-roadmap" element={<Page57 />} />
            <Route path="/blog/prompt-engineering-techniques-for-developers" element={<Page58 />} />
            <Route path="/blog/kubernetes-roadmap-for-working-professionals-2026" element={<Page59 />} />
            <Route path="/blog/10-best-ai-tools-for-devops-engineers-2026" element={<Page60 />} />
            <Route path="/blog/devops-deployment-strategies-blue-green-canary-rolling" element={<Page61 />} />
            <Route path="/blog/what-is-aws-agentic-engineering-emerging-cloud-role" element={<Page62 />} />
            <Route path="/blog/cicd-pipeline-best-practices-github-actions" element={<Page63 />} />
            <Route path="/blog/devops-interview-questions-for-experienced-professionals" element={<Page64 />} />
            <Route path="/blog/highest-paying-ai-careers-in-india" element={<Page65 />} />
            <Route path="/blog/platform-engineering-vs-devops-difference" element={<Page66 />} />
            <Route path="/blog/tech-career-2026-future-proof-it-skills" element={<Page67 />} />
            <Route path="/blog/cloud-migration-checklist-for-it-teams" element={<Page68 />} />
            <Route path="/blog/how-to-switch-to-cloud-computing-without-quitting-job" element={<Page69 />} />
            <Route path="/blog/linux-commands-every-cloud-devops-engineer-should-know" element={<Page70 />} />
            <Route path="/blog/kubernetes-interview-questions-experienced-engineers" element={<Page71 />} />
            <Route path="/blog/jenkins-vs-github-actions-vs-gitlab-ci" element={<Page72 />} />
            <Route path="/blog/platform-engineering-next-evolution-of-devops" element={<Page73 />} />
            <Route path="/blog/linux-interview-questions-for-cloud-devops-engineers" element={<Page74 />} />
            <Route path="/blog/devops-cv-that-gets-interview-calls" element={<Page75 />} />
            <Route path="/blog/how-to-join-it-sector-types-of-it-jobs" element={<Page76 />} />
            <Route path="/blog/top-devsecops-tools-every-devops-engineer-should-learn" element={<Page77 />} />
            <Route path="/blog/rag-architecture-aws-complete-guide" element={<Page78 />} />
            <Route path="/blog/cloud-engineer-salary-india-2026" element={<Page79 />} />
            <Route path="/blog/aws-projects-for-resume" element={<Page80 />} />
            <Route path="/blog/aws-services-cloud-engineer-interview-guide" element={<Page81 />} />
            <Route path="/blog/future-proof-it-careers-ai-wont-replace" element={<Page82 />} />
            <Route path="/blog/what-is-infrastructure-as-code-iac" element={<Page83 />} />
            <Route path="/blog/terraform-roadmap-cloud-devops-engineers" element={<Page84 />} />
            <Route path="/blog/saa-c03-exam-guide" element={<Page85 />} />
            <Route path="/blog/aws-interview-questions-and-answers-2026" element={<Page86 />} />
            <Route path="/blog/top-genai-projects-for-resume" element={<Page87 />} />
            <Route path="/blog/rag-vs-fine-tuning-enterprise-ai-applications" element={<Page88 />} />
            <Route path="/blog/ai-engineer-vs-generative-ai-engineer-salary-india" element={<Page89 />} />
            <Route path="/blog/aws-solutions-architect-salary-2026" element={<Page90 />} />
            <Route path="/blog/kubernetes-in-production-best-practices" element={<Page91 />} />
            <Route path="/blog/rag-chunking-strategies-how-to-split-documents" element={<Page92 />} />
            <Route path="/generative-ai-skills-2026" element={<Page93 />} />
            <Route path="/model-context-protocol-mcp-vs-apis" element={<Page94 />} />
            <Route path="/cloud-certification-roadmap-2026" element={<Page95 />} />
            <Route path="/devops-interview-questions-working-professionals" element={<Page96 />} />
            <Route path="/cka-preparation-2026-guide" element={<Page97 />} />
            <Route path="/which-google-cloud-certification-should-you-choose" element={<Page98 />} />
            <Route path="/terraform-associate-certification-worth-it-guide" element={<Page99 />} />
            <Route path="/in-demand-tech-skills-2026" element={<Page100 />} />
            <Route path="/cloud-certification-path-aws-azure-kubernetes-ai" element={<Page101 />} />
            <Route path="/platform-engineer-salary-india" element={<Page102 />} />
            <Route path="/what-is-gitops-vs-traditional-cicd" element={<Page103 />} />
            <Route path="/aws-well-architected-framework-guide" element={<Page104 />} />
            <Route path="/what-is-aws-vpc-secure-cloud-network-design" element={<Page105 />} />
            <Route path="/aws-iam-explained-users-roles-policies-permissions" element={<Page106 />} />
            <Route path="/rag-evaluation-metrics-guide" element={<Page107 />} />
            <Route path="/aws-disaster-recovery-rto-rpo-strategy" element={<Page108 />} />
            <Route path="/cloud-engineer-salary-product-vs-service-company" element={<Page109 />} />
            <Route path="/how-does-aws-auto-scaling-work-scalable-applications" element={<Page110 />} />
            <Route path="/how-to-become-an-mlops-engineer-in-2026" element={<Page111 />} />
            <Route path="/how-to-secure-ci-cd-pipeline" element={<Page112 />} />
            <Route path="/cka-practice-guide-kubernetes-tasks" element={<Page113 />} />
            <Route path="/agentic-ai-vs-generative-ai" element={<Page114 />} />
            <Route path="/devsecops-engineer-vs-cloud-security-engineer-salary" element={<Page115 />} />
            <Route path="/can-you-learn-aws-without-programming" element={<Page116 />} />
            <Route path="/cka-certification-worth-it-2026" element={<Page117 />} />
            <Route path="/ai-agents-explained" element={<Page118 />} />
            <Route path="/networking-mistakes-that-break-applications" element={<Page119 />} />
            <Route path="/generative-ai-in-devops" element={<Page120 />} />
            <Route path="/reasons-llms-give-wrong-answers" element={<Page121 />} />
            <Route path="/genai-developer-portfolio-7-projects" element={<Page122 />} />
            <Route path="/devops-to-mlops-salary" element={<Page123 />} />
            <Route path="/networking-basics-it-professional" element={<Page124 />} />
            <Route path="/ai-powered-cloud-infrastructure" element={<Page125 />} />
            <Route path="/what-does-an-mlops-engineer-do" element={<Page126 />} />
            <Route path="/kubernetes-pod-troubleshooting" element={<Page127 />} />
            <Route path="/desktop-support-to-azure-administrator-guide" element={<Page128 />} />
            <Route path="/what-is-observability-in-devops-logs-metrics-traces-opentelemetry" element={<Page129 />} />
            <Route path="/software-tester-to-sre" element={<Page130 />} />
            <Route path="/cloud-skills-to-learn-after-first-it-job" element={<Page131 />} />
            <Route path="/generative-ai-career-for-non-coders" element={<Page132 />} />
            <Route path="/technical-support-to-devops-in-bangalore" element={<Page133 />} />
            <Route path="/in-demand-cloud-skills-in-bangalore-2026" element={<Page134 />} />
            <Route path="/react-developer-to-cloud-engineer" element={<Page135 />} />
            <Route path="/manual-tester-to-ai-engineer" element={<Page136 />} />
            <Route path="/cloud-skills-for-scrum-masters" element={<Page137 />} />
            <Route path="/frontend-developer-to-cloud-engineer-roadmap" element={<Page138 />} />
            <Route path="/troubleshooting-skills-for-generative-ai-careers" element={<Page139 />} />
            <Route path="/aws-vs-linux-vs-devops-for-system-administrators" element={<Page140 />} />
            <Route path="/full-stack-developer-to-cloud-engineer" element={<Page141 />} />
            <Route path="/ci-cd-projects-for-software-testers" element={<Page146 />} />
            <Route path="/cloud-administrator-vs-cloud-engineer" element={<Page142 />} />
            <Route path="/service-desk-to-cloud-engineer" element={<Page143 />} />
            <Route path="/backend-developer-to-devops-engineer" element={<Page145 />} />
            <Route path="/devops-engineer-after-it-support-experience" element={<Page147 />} />
            <Route path="/generative-ai-for-program-managers" element={<Page148 />} />
            <Route path="/best-it-training-institutes-in-bangalore" element={<Page144 />} />
            <Route path="/genai-applications-for-qa-automation-engineers" element={<Page149 />} />
            <Route path="/best-generative-ai-training-institutes-in-bengaluru" element={<Page151 />} />
            <Route path="/cloud-vs-devops-vs-genai-for-it-support" element={<Page152 />} />
            <Route path="/it-careers-without-programming" element={<Page153 />} />
            <Route path="/it-jobs-most-exposed-to-ai" element={<Page154 />} />
            <Route path="/top-cloud-devops-courses-in-bengaluru" element={<Page155 />} />
            <Route path="/will-ai-replace-it-support-engineers" element={<Page156 />} />
            <Route path="/llm-engineer-salary-in-india" element={<Page157 />} />
            <Route path="/it-skills-to-learn-in-2026" element={<Page158 />} />


            {/* Resume Builder Routes */}
            <Route path="/microresume" element={<ResHero />} />
            <Route path="/create-resume" element={<FormComponent />} />
            <Route path="/create-resume2" element={<FormComponent_2 />} />
            <Route path="/create-resume3" element={<FormComponent_3 />} />
            <Route path="/choose-template" element={<ChooseTemplate />} />
            <Route path="/resume/Template1" element={<Resume />} />
            <Route path="/resume/Template2" element={<Resume2 />} />
            <Route path="/resume/Template3" element={<Resume3 />} />
            <Route path="/resume/Template4" element={<Resume4 />} />
            <Route path="/resume/Template5" element={<Resume5 />} />
            <Route path="/resume/Template6" element={<Resume6 />} />
            <Route path="/resume/Template7" element={<Resume7 />} />
            <Route path="/resume/Template8" element={<Resume8 />} />
            <Route path="/resume/Template9" element={<Resume9 />} />
            <Route path="/resume/Template10" element={<Resume10 />} />

            {/* Other Application Routes */}
            <Route exact path='/Recognition' element={<Recognition />} />
            <Route exact path='/Aws_Course_Details_Page' element={<Aws_Course_Details_Page />} />
            <Route exact path='/Python_Course_Details_Page' element={<Python_Course_Details_Page />} />
            <Route exact path='/Mysql_Course_Details_Page' element={<Mysql_Course_Details_Page />} />
            <Route exact path='/e_book_2024' element={<E_Book_2024 />} />
            <Route exact path='/streamyardpage' element={<Streamyardpage />} />
            <Route exact path='/TestimonialFreshers' element={<TestimonialFreshers />} />
            <Route exact path='/TestimonialExperienced' element={<TestimonialExperienced />} />
            <Route exact path='/TestimonialsPage' element={<TestimonialsPage />} />
            <Route exact path='/ebook' element={<Ebook />} />
            <Route exact path='/survey' element={<Survey />} />
            <Route exact path='/courses' element={<Courses />} />
            <Route exact path='/whatsapp' element={<Whatsapp />} />
            <Route exact path='/kn_blogs' element={<Kn_Blogs />} />
            <Route exact path='/joindemo' element={<JoinDemo />} />
            <Route exact path='/aws_faq' element={<AWS_FAQ />} />
            <Route exact path='/demo_form' element={<Demo_Form />} />
            <Route exact path='/aws_devops' element={<AWS_DevOps />} />
            <Route exact path='/bankdetails' element={<BankDetails />} />
            <Route exact path='/thankyou' element={<ThankYou />} />
            <Route exact path='/thank_you' element={<Thank_You />} />
            <Route exact path='/refund-and-course-rescheduling-policy' element={<Privacy />} />
            <Route exact path='/task_steps' element={<Task_Steps />} />
            <Route exact path='/webinar_youtube_live' element={<Webinar_Youtube_Live />} />
            <Route exact path='/webinar_registration' element={<Webinar_registration />} />
            <Route exact path='/company_vacancies' element={<Company_Vacancies />} />
            <Route exact path='/webinar_link' element={<Webinar_Link />} />
            <Route exact path='/e_book' element={<E_Book />} />
            <Route exact path='/e_book_sheet_fill' element={<EBook_SheetFill />} />
            <Route exact path='/ship-and-delivery-policy' element={<Ship_Delivery_Policy />} />
            <Route exact path='/aws_devops_curriculm' element={<AWS_DevOps_Curriculm />} />
            <Route exact path='/aws_demo_link' element={<AWS_Demo_Link />} />
            <Route exact path='/webinar' element={<Webinar />} />
            <Route exact path='/Cloud_PlacementDrive_Form' element={<Cloud_PlacementDrive_Form />} />
            <Route exact path='/Offcampus_PlacementDrive_Form' element={<Offcampus_PlacementDrive_Form />} />
            <Route exact path='/Testimonials' element={<Testimonials />} />
            <Route exact path='/YTFullCoursePage' element={<YTFullCoursePage />} />
            <Route exact path='/Legal' element={<Legal />} />
            <Route exact path='/termsandconditions' element={<Terms />} />
            <Route exact path='/bookyourseat' element={<PaymentLink />} />
            <Route exact path='/devopsforkannadigas' element={<Devopsforkannadigas />} />
            <Route exact path='/pythonforkannadigas' element={<Pythonforkannadigas />} />
            <Route exact path='/PowerBi' element={<PowerBi />} />
            <Route exact path='/java-at' element={<Java_at />} />
            <Route exact path='/topper-of-the-month' element={<Topper_of_the_month />} />
            <Route exact path='/pythonquiz' element={<PythonQuiz />} />
            <Route exact path='/awsdevops2' element={<Awsdevops />} />
            <Route exact path='/Pythonfullstack' element={<Pythonfullstack />} />
            <Route exact path='/Pythonfull-stack' element={<Pythonfullstack2 />} />
            <Route exact path='/dockerandkubernetes' element={<DockerAndKubernetesCertificationPage />} />
            <Route exact path='/offcampus_placementdrive_jan2025' element={<Offcampus_PlacementDrive_Jan2025 />} />
            <Route exact path='/skillgapanalyzer' element={<SkillGapAnalyzer />} />
            <Route exact path='/it-salary-growth-calculator' element={<Roi_Calculator />} />
            <Route exact path='/salary-calculator' element={<LayoutWithoutNavbar><SalaryCalculator /></LayoutWithoutNavbar>} />
            <Route exact path='/tech-trainer-kannadiga' element={<TrainersHiringForm />} />
            <Route exact path='/interviewquestions' element={<InterviewQuestions />} />
            <Route exact path='/androidapp' element={<AndroidApp />} />
            <Route exact path='/student-intake-form' element={<Student_Intake_Form />} />
            <Route exact path='/downloadcurriculum' element={<Downloadcurriculum />} />
            <Route exact path='/3-step-framework' element={<Singlepage />} />
            <Route exact path='/3-step-framework-ga' element={<Singlepage2 />} />
            <Route exact path='/3-step-framework-bl' element={<Singlepage3 />} />
            <Route exact path='/video' element={<Video />} />
            <Route exact path='/video2' element={<Video2 />} />
            <Route exact path='/video3' element={<Video3 />} />
            <Route exact path='/prime' element={<Prime />} />
            <Route exact path='/sh' element={<Cashback />} />
            <Route exact path='/awsdevops' element={<Awsdevops2 />} />
            <Route exact path='/genai' element={<Genai />} />
            <Route exact path='/kaoffer' element={<Kannadaoffer />} />
            <Route exact path='/anniversaryoffer' element={<Sixthoffer />} />
            <Route exact path='/newyear' element={<NewYear />} />
            <Route exact path='/th' element={<Th />} />
            {/* <Route exact path='/techharate' element={<Masterclass2 />} /> */}
            <Route exact path='/masterclass' element={<WebinarPage />} />
            <Route exact path='/dfk' element={<DFK />} />
            <Route exact path='/cfk2' element={<CFK />} />
            <Route exact path='/dfkvideo' element={<Video4 />} />
            <Route exact path='/demovideo1' element={<Demo1 />} />
            <Route exact path='/demovideo2' element={<Demo2 />} />
            <Route exact path='/demovideo3' element={<Demo3 />} />
            <Route exact path='/demopage' element={<Demopage />} />
            <Route exact path='/genaidemo' element={<Genaidemo />} />
            <Route exact path='/quiz' element={<QuizApp />} />
            <Route exact path='/thankyou1' element={<Thankyoupage1 />} />
            <Route exact path='/thankyou2' element={<Thankyoupage2 />} />
            <Route exact path='/thankyou3' element={<Thankyoupage3 />} />
            <Route exact path='/thankyou4' element={<Thankyoupage4 />} />
            <Route exact path='/thankyou5' element={<Thankyoupage5 />} />
            <Route exact path='/thankyou6' element={<Thankyoupage6 />} />
            <Route exact path='/thankyou7' element={<Thankyoupage7 />} />
            <Route exact path='/thankyou8' element={<Thankyoupage8 />} />
            <Route exact path='/thankyou9' element={<Thankyoupage9 />} />
            <Route exact path='/thankyoupage' element={<ThankyouPageforNonIT />} />
            <Route exact path='/cfk' element={<Cloudforkannadigas2 />} />
            <Route exact path='/cloud-devops-certification' element={<Adpage />} />
            <Route exact path='/tech-course' element={<Adpage />} />
            <Route exact path='/genaicourse' element={<Adpage2 />} />
            <Route exact path='/afk' element={<Aiforkannadigas />} />

          </Routes>
        </Suspense>
        </main>
      </ResumeDataProvider>
      {showNavAndFooter && <Footer />}
    </>
  );
};

function App() {
  const [searchedResults, setSearchedResults] = useState([]);
  const [alertStatus, setAlertStatus] = useState(false);

  const handleAlert = () => {
    setAlertStatus(!alertStatus);
    setTimeout(() => (
      setAlertStatus(false)
    ), 4000);
  };

  const ref = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      ref.current?.click();
    }, 1000);
  }, []);

  return (
<div className="App relative w-full h-full overflow-x-clip font-poppins">
    <div className='absolute top-0 bg-[#f9f8fd] -z-10 w-full h-full'>
        <div className='relative h-full'></div>
      </div>

      <div className='w-full h-full relative'>
        {/* Alert Component */}
        <div className={`${alertStatus ? "block" : 'hidden'} fixed z-40 w-full h-screen flex justify-center items-end py-20 sm:items-end sm:py-5`}>
          <div className="bg-green-500 rounded-b text-white px-4 py-1 shadow-md" role="alert">
            <div className="flex">
              <div className="py-1">
                <svg className="fill-current h-6 w-6 text-white mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                </svg>
              </div>
              <div className='flex flex-col justify-center items-start'>
                <p className="font-medium">Submitted Successfully</p>
                <p className="font-light text-xs xl:text-sm">Our Team will contact you shortly</p>
              </div>
            </div>
          </div>
        </div>

        <Router>
          <AppInner setSearchedResults={setSearchedResults} handleAlert={handleAlert} searchedResults={searchedResults} />
        </Router>
      </div>
    </div>
  );
}
export default App;